import { InvestigatorSeverityStats } from "./SeverityWiseIncident";
import { InvestigatorDepartmentStats } from "./DepartmentWiseIncident";

export function InvestigatorStats(props) {
  const {
    user,
    severities,
    departments,
    imageSrc,
    dateRangeList,
    dateRange,
    mode,
  } = props;
  const Field = { attribute: "dateRange", type: "select" };
  const Columns = [
    {
      title: "",
      attribute: "label",
      width: "16%",
    },
    {
      title: "Max Aging",
      attribute: "max_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
    },
    {
      title: "Avg Aging",
      attribute: "avg_aging",
      classes: { color: "text-filled" },
      highlight: { header: true, cell: false },
    },
    {
      title: "OVERALL",
      attribute: "total",
      id: "Overall",
      highlight: { header: true, cell: true },
      overallFlag: true,
    },
    {
      title: "Closed",
      attribute: "COMPLETE",
      id: "COMPLETE",
    },
    {
      title: "Started",
      attribute: "STARTED",
      id: "STARTED",
    },
    {
      title: "Open",
      attribute: "OPEN",
      id: "PENDING",
    },
    {
      title: "Other",
      attribute: "OTHER",
      id: "INVALID",
    },
  ];

  return (
    <div className="o-auto">
      <InvestigatorSeverityStats
        Field={Field}
        Columns={Columns}
        user={user}
        severities={severities}
        imageSrc={imageSrc}
        dateRange={dateRange}
        dateRangeList={dateRangeList}
        mode={mode}
      />
      {(mode === "full" || mode === "export_everything") && (
        <>
          <InvestigatorDepartmentStats
            Field={Field}
            Columns={Columns}
            user={user}
            departments={departments}
            imageSrc={imageSrc}
            dateRange={dateRange}
            dateRangeList={dateRangeList}
          />
          <div style={{ paddingTop: "100px" }}>
            <hr className="nm-hr nm-hr--center" />
          </div>
        </>
      )}
    </div>
  );
}
